import { useParams } from 'react-router-dom';

const LinkBuilder = (url) => {
  const { lang = 'en' } = useParams();
  return lang && lang !== 'en' ? `/${lang}${url}` : url;
};

export default LinkBuilder;
